import React from 'react'
import PropTypes from 'prop-types'

import Image from '@components/image/image.component'
import ParsedText from '@components/parsed-text/parsed-text.component'
import TipConfirmation from '@components/tip-confirmation/tip-confirmation.component'
import TipConfirmationV2 from '@components/tip-confirmation-v2/tip-confirmation-v2.component'

import useStyles from './chat-message-content.style'

const ChatMessageContent = (props) => {
  const { message } = props

  const classes = useStyles(props)

  let { type } = message

  if (message.image) {
    type = 'image'
  }

  switch (type) {
  case 'image':
    return <Image
      className={classes.messageImage}
      modal
      src={message.image}
    />
  case 'tip-confirmation':
    return <TipConfirmation message={message} />
  case 'tip-confirmation-v2':
    return <TipConfirmationV2 message={message} />
  default:
    return <ParsedText
      className={classes.text}
      location={message.location}
      text={message.text}
    />
  }
}

ChatMessageContent.propTypes = {
  message: PropTypes.shape({}).isRequired
}

export default ChatMessageContent
